import React from "react";

const GeneralPages = {
  InternalServerError:
    "An error occurred while serving your request. Please try again later.",
  DateOfBirthOutOfRange: "The date of birth you have entered is out of range",
  SelectADateOfBirth: "Please select your date of birth",
  SelectAValidDateOfBirth: "Please select valid date of birth",
  MembershipNumber: "Membership number",
  CorrectErrors: "Please correct the following errors:",
  ButtonBackText: "Back",
  GPHelpHeadingLinkText: "FAQs",
  MSKHelpHeadingLinkText: "Help",
  HelpHeadingLinkText: "Help",
  MoreHelpLinkText: "View more help",
  GPMoreHelpLinkText: "",
  ButtonEditText: "Edit",
  ButtonUpdateText: "Update",
  ButtonCancelText: "Cancel",
  ButtonDeleteText: "Delete",
  ButtonYesText: "Yes",
  ButtonNoText: "No",
  OpeningHours: {
    International: "24 hours a day, 365 days a year",
    Saga: (
      <React.Fragment>
        8am-8pm, Monday - Friday;
        <br />
        9am-5pm, Saturday
      </React.Fragment>
    ),
    Any: "8am-8pm, Monday-Friday; 9am-5pm Saturday"
  },
  OpeningHoursForLocationCorporateHub:
    "8am-8pm, Monday-Friday; 9am-5pm Saturday and bank holidays",
  OpeningHoursForTechnicalHelpline: {
    HOL: "8am - 6pm, Monday - Friday",
    Any: "8am-5pm, Monday-Friday; 9am-5pm Saturday"
  },
  PhoneNumbers: {
    Any: <React.Fragment>0800 302 9133</React.Fragment>,
    HOL: <React.Fragment>01202 544 032</React.Fragment>
  }
};

export default GeneralPages;
